import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

const Layout: React.FC = () => {
  return (
    <main className="flex">
    <Navbar />
    <article className="w-full h-screen bg-primary/50 overflow-y-scroll">
      <Outlet />
    </article>
  </main>
  );
};

export default Layout;
